import { render } from "./NotFoundView.vue?vue&type=template&id=ffd48a3e"
const script = {}

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__